module.exports = __webpack_public_path__ + "static/media/spotifybanner.331f3756.png";